import React from 'react';

import box from '../../assets/images/boxIcon.png';

const BoxIcon = () => <img width="130px" src={box} alt="tablet icon"></img>;

export default BoxIcon;
